<template>
    <tbody :index="index">
        <!-- {{ inforBlock }} -->
        <template v-if="formGroupLayout == 'row'">
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_RADIO && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td colspan="1" :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            :style="`display: grid; grid-template-columns: repeat(${inforBlock.number_of_items_displayed_per_line}, auto);column-gap: 1rem;`"
                                        >
                                            <div v-for="item in inforBlock.option_value" :key="`RadioForm-${item.unique_key}-${inforBlock.id}`">
                                                <InputRadio
                                                    class="mb-2"
                                                    :model.sync="configBlock.modelRadio[inforBlock.id].radio"
                                                    :name="`RadioForm-${inforBlock.id}`"
                                                    :id="`RadioForm-${indexRadio}-${item.unique_key}-${inforBlock.id}`"
                                                    :value="item.unique_key"
                                                    :label="item.value"
                                                    :disabled="disabled"
                                                    :config.sync="configBlock.validateRadio[inforBlock.id].configField"
                                                    @change="handleChangeRadio"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            v-if="inforBlock?.setting_others?.other_use"
                                            :class="`text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            <InputRadio
                                                class="mb-2"
                                                :model.sync="configBlock.modelRadio[inforBlock.id].radio"
                                                :name="`RadioForm-${inforBlock.id}`"
                                                :id="`RadioForm-Others-${indexRadio}-${inforBlock.id}`"
                                                :value="VALUE_ETC"
                                                :label="inforBlock.setting_others.label_other"
                                                :disabled="disabled"
                                                :config.sync="configBlock.validateRadio[inforBlock.id].configField"
                                                @change="handleChangeRadio"
                                            />
                                            <template>
                                                <div :class="`d-flex flex-wrap`" :style="`gap: 10px; justify-content:${choicePlacement('answer')}`">
                                                    <InputText
                                                        :id="`RadioForm-Others-${index}-${indexRadio}-${inforBlock.id}`"
                                                        :model.sync="configBlock.modelRadio[inforBlock.id].text"
                                                        :config.sync="configBlock.validateRadio[inforBlock.id].configFieldText"
                                                        :disabled="configBlock.modelRadio[inforBlock.id].radio !== VALUE_ETC || disabled"
                                                        @blur="
                                                            handleValidateField(inforBlock, configBlock.validateRadio[inforBlock.id].configFieldText)
                                                        "
                                                    />
                                                </div>
                                                <div
                                                    v-if="configBlock.validateRadio[inforBlock.id].configFieldText.error"
                                                    :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                                >
                                                    {{ configBlock.validateRadio[inforBlock.id].configFieldText.errorField }}
                                                </div>
                                            </template>
                                        </div>
                                        <div v-if="inforBlock?.setting_others?.uncheck_use" :class="`mt-2 text-${choicePlacement('answer')}`">
                                            <button
                                                class="btn btn-light"
                                                :disabled="!configBlock.modelRadio[inforBlock.id].radio"
                                                @click="onHandleRemoveRadio"
                                            >
                                                {{
                                                    inforBlock.setting_others?.label_uncheck
                                                        ? inforBlock.setting_others.label_uncheck
                                                        : $t('managerForm.settingPage.uncheck')
                                                }}
                                            </button>
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validateRadio[inforBlock.id].configField.error &&
                                                !configBlock.validateRadio[inforBlock.id].configField.valueSync
                                            "
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateRadio[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{
                                configBlock.modelRadio[inforBlock.id].radio == VALUE_ETC
                                    ? `${inforBlock.setting_others.label_other}(${configBlock.modelRadio[inforBlock.id].text})`
                                    : renderValueOption(configBlock.modelRadio[inforBlock.id].radio)
                            }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SELECT && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td colspan="1" :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div class="select_out">
                                        <Multiselect
                                            :id="`SelectForm-${inforBlock.id}-${index}-${indexMultiselect}`"
                                            :value.sync="configBlock.modelSelect[inforBlock.id]"
                                            :options="onHandleMergeOptionValues(inforBlock.option_value, inforBlock)"
                                            :config.sync="configBlock.validateSelect[inforBlock.id].configField"
                                            style="width: 200px"
                                            @remove="handleRemoveMultiselect(inforBlock, configBlock.validateSelect[inforBlock.id].configField)"
                                            @select="handleChangeMultiselect"
                                            :disabled="disabled"
                                        />
                                        <div
                                            v-if="configBlock.validateSelect[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateSelect[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ renderValueSelect(configBlock.modelSelect[inforBlock.id]) }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_CHECKBOX && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td
                        colspan="1"
                        :class="`fm-answer text-${inforBlock?.choice_placement_specification_answer}`"
                        :style="onHandleSetStyleAnswer(inforBlock)"
                    >
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            :style="`display: grid; grid-template-columns: repeat(${inforBlock.number_of_items_displayed_per_line}, auto)`"
                                        >
                                            <div v-for="item in inforBlock.option_value" :key="`CheckBoxForm-${item.unique_key}-${inforBlock.id}`">
                                                <InputCheckBox
                                                    class="mr-3 mb-2"
                                                    :id="`CheckBoxForm-${indexCheckbox}-${item.unique_key}-${inforBlock.id}`"
                                                    :model.sync="configBlock.modelCheckbox[inforBlock.id].checked"
                                                    :config.sync="configBlock.validateCheckbox[inforBlock.id].configField"
                                                    :value="item.unique_key"
                                                    :label="item.value"
                                                    :disabled="disabledLimit[item.unique_key] || disabled"
                                                    @change="
                                                        onChangeCheckbox(
                                                            configBlock.modelCheckbox[inforBlock.id],
                                                            configBlock.validateCheckbox[inforBlock.id]
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <div
                                            v-if="inforBlock?.setting_others?.other_use"
                                            :class="`text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            <InputCheckBox
                                                :id="`OtherCheckBoxForm-${indexCheckbox}-${inforBlock.id}`"
                                                class="mr-3 mb-2"
                                                :model.sync="configBlock.modelCheckbox[inforBlock.id].checked"
                                                :value="VALUE_ETC"
                                                :label="inforBlock.setting_others.label_other"
                                                :disabled="disabledLimit[VALUE_ETC] || disabled"
                                                :config.sync="configBlock.validateCheckbox[inforBlock.id].configField"
                                                @change="
                                                    onChangeCheckbox(
                                                        configBlock.modelCheckbox[inforBlock.id],
                                                        configBlock.validateCheckbox[inforBlock.id]
                                                    )
                                                "
                                            />
                                            <template>
                                                <div :class="`d-flex flex-wrap`" :style="`gap: 10px; justify-content:${choicePlacement('answer')}`">
                                                    <InputText
                                                        :id="`OtherCheckBoxForm-${index}-${indexTextCheckbox}-${inforBlock.id}`"
                                                        :model.sync="configBlock.modelCheckbox[inforBlock.id].text"
                                                        :config.sync="configBlock.validateCheckbox[inforBlock.id].configFieldText"
                                                        :disabled="!configBlock.modelCheckbox[inforBlock.id].checked.includes(VALUE_ETC) || disabled"
                                                        @blur="
                                                            handleValidateField(
                                                                inforBlock,
                                                                configBlock.validateCheckbox[inforBlock.id].configFieldText
                                                            )
                                                        "
                                                    />
                                                </div>
                                                <div
                                                    v-if="configBlock.validateCheckbox[inforBlock.id].configFieldText.error"
                                                    :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                                >
                                                    {{ configBlock.validateCheckbox[inforBlock.id].configFieldText.errorField }}
                                                </div>
                                            </template>
                                        </div>
                                        <div
                                            v-if="inforBlock?.setting_others?.uncheck_use"
                                            :class="`text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            <InputCheckBox
                                                :id="`NotApplicableCheckBoxForm-${indexCheckbox}-${inforBlock.id}`"
                                                :model.sync="configBlock.modelCheckbox[inforBlock.id].checked"
                                                :value="VALUE_NAC"
                                                :label="inforBlock.setting_others.label_uncheck"
                                                :disabled="disabledLimit[VALUE_NAC] || disabled"
                                                :config.sync="configBlock.validateCheckbox[inforBlock.id].configField"
                                                @change="
                                                    onChangeCheckbox(
                                                        configBlock.modelCheckbox[inforBlock.id],
                                                        configBlock.validateCheckbox[inforBlock.id],
                                                        'labelUncheck'
                                                    )
                                                "
                                            />
                                        </div>
                                        <div
                                            v-if="configBlock.validateCheckbox[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateCheckbox[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ onHandleJoinNameCheckbox(inforBlock.option_value, configBlock.modelCheckbox[inforBlock.id]) }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td colspan="1" :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <UploadFileCommon
                                            :class="`text-${inforBlock?.choice_placement_specification_answer}`"
                                            @dataFile="handleFileForm"
                                            :id="`UploadFileForm-${inforBlock.id}-${indexUploadFile}`"
                                            :typeUpload="`file`"
                                            :config="{
                                                isUpDemo: true,
                                                isPreview: false,
                                                maxSize: convertMbToKb(inforBlock.block_upload_file.maximum_file_size),
                                                allowedExtension: onHandleJoinExtension(inforBlock.block_upload_file.allowed_extensions)
                                            }"
                                            :disabled="disabled"
                                        />
                                        <p :class="`mb-0 text-${inforBlock?.choice_placement_specification_answer}`">
                                            {{
                                                !inforBlock?.block_upload_file?.allowed_extensions
                                                    ? $t('managerForm.settingPage.noteAllowedUpload')
                                                    : `※アップロード可能なファイル形式：${inforBlock.block_upload_file.allowed_extensions}`
                                            }}
                                        </p>
                                        <div
                                            v-if="configBlock.validateUploadFile[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateUploadFile[inforBlock.id].configField.errorField }}
                                        </div>
                                        <div
                                            v-if="configBlock.modelUploadFile[inforBlock.id]?.origin_name"
                                            class="d-flex align-items-center my-2"
                                            :style="`justify-content:${choicePlacement('answer')}`"
                                        >
                                            <i
                                                v-if="arrImageExtension.includes(configBlock.modelUploadFile[inforBlock.id]?.extension.toLowerCase())"
                                                class="ri-file-image-line"
                                            ></i>
                                            <i v-else class="ri-file-line"></i>
                                            <p class="mb-0">{{ configBlock.modelUploadFile[inforBlock.id]?.origin_name }}</p>
                                            <span
                                                class="ml-2"
                                                style="cursor: pointer; font-size: 20px"
                                                @click="onHandleRemoveFile(inforBlock, configBlock.validateUploadFile[inforBlock.id].configField)"
                                                ><i class="ri-close-line" style="vertical-align: bottom"></i
                                            ></span>
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            <p class="mb-0">{{ configBlock.modelUploadFile[inforBlock.id]?.origin_name }}</p>
                        </div>
                    </td>
                </tr>
            </template>
            <template
                v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE && onHandleShowBlockOfPageConfirm(inforBlock.block_type)"
            >
                <tr :id="inforBlock.id">
                    <td colspan="1" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div class="select_out">
                                        <Multiselect
                                            :id="`SelectProvince-${inforBlock.id}-${index}-${indexProvince}`"
                                            :value.sync="configBlock.modelProvince[inforBlock.id]"
                                            :options="onHandleMergeOptionValues(inforBlock.option_value, inforBlock)"
                                            :config.sync="configBlock.validateProvince[inforBlock.id].configField"
                                            @select="handleChangeBlockProvince"
                                            @remove="handleValidateField(inforBlock, configBlock.validateProvince[inforBlock.id].configField)"
                                            :disabled="disabled"
                                            style="width: 200px"
                                        />
                                        <div
                                            v-if="configBlock.validateProvince[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateProvince[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ renderValueSelect(configBlock.modelProvince[inforBlock.id]) }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="1" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            class=""
                                            :style="`display: grid; grid-template-columns: repeat(${inforBlock.number_of_items_displayed_per_line}, auto)`"
                                        >
                                            <div v-for="item in inforBlock.option_value" :key="`RemainingSeats-${item.unique_key}-${inforBlock.id}`">
                                                <div
                                                    :class="`d-flex flex-wrap`"
                                                    :style="`gap: 10px; justify-content:${choicePlacement('answer')}`"
                                                    style="gap: 5px"
                                                >
                                                    <InputRadio
                                                        class="mb-2"
                                                        :model.sync="configBlock.modelRemainingBox[inforBlock.id]"
                                                        :name="`RemainingSeats-${inforBlock.id}`"
                                                        :id="`RemainingSeats-${item.unique_key}-${inforBlock.id}-${indexRemainingBox}`"
                                                        :value="item.unique_key"
                                                        :label="item.value"
                                                        :config.sync="configBlock.validateRemainingBox[inforBlock.id].configField"
                                                        @change="handleChangeRemainingBox"
                                                        :disabled="disabled"
                                                    />
                                                    <div v-if="inforBlock.block_remaining_number.remaining_number === 1">
                                                        <span
                                                            :style="`color: ${inforBlock.block_remaining_number.color_text ?? ''}; font-size: 12px`"
                                                            class="fm_limit_radio_remainder pt-1"
                                                        >
                                                            {{
                                                                `${inforBlock.block_remaining_number.display_content === 1 ? `(${inforBlock.block_remaining_number.remaining_text}${item.number_of_receptions}${inforBlock.block_remaining_number.text_after_remaining_number})` : inforBlock.block_remaining_number.label_other}`
                                                            }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-if="!inforBlock.order_required && inforBlock?.setting_others?.uncheck_use"
                                            :class="`mt-2 text-${choicePlacement('answer')}`"
                                        >
                                            <button
                                                class="btn btn-light"
                                                :disabled="!configBlock.modelRemainingBox[inforBlock.id] || disabled"
                                                @click="onHandleRemoveRemainingBox"
                                            >
                                                {{
                                                    inforBlock.setting_others?.label_uncheck
                                                        ? inforBlock.setting_others.label_uncheck
                                                        : $t('managerForm.settingPage.uncheck')
                                                }}
                                            </button>
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validateRemainingBox[inforBlock.id].configField.error &&
                                                !configBlock.validateRemainingBox[inforBlock.id].configField.valueSync
                                            "
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateRemainingBox[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ renderValueOption(configBlock.modelRemainingBox[inforBlock.id]) }}
                        </div>
                    </td>
                </tr>
            </template>
        </template>
        <template v-else>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_RADIO && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            class=""
                                            :style="`display: grid; grid-template-columns: repeat(${inforBlock.number_of_items_displayed_per_line}, auto); column-gap: 1rem;`"
                                        >
                                            <div v-for="item in inforBlock.option_value" :key="`RadioForm-${item.unique_key}-${inforBlock.id}`">
                                                <InputRadio
                                                    class="mb-2"
                                                    :model.sync="configBlock.modelRadio[inforBlock.id].radio"
                                                    :name="`RadioForm-${inforBlock.id}`"
                                                    :id="`RadioForm-${indexRadio}-${item.unique_key}-${inforBlock.id}`"
                                                    :value="item.unique_key"
                                                    :label="item.value"
                                                    :disabled="disabled"
                                                    :config.sync="configBlock.validateRadio[inforBlock.id].configField"
                                                    @change="handleChangeRadio"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            v-if="inforBlock?.setting_others?.other_use"
                                            :class="`text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            <InputRadio
                                                class="mb-2"
                                                :model.sync="configBlock.modelRadio[inforBlock.id].radio"
                                                :name="`RadioForm-${inforBlock.id}`"
                                                :id="`RadioForm-Others-${indexRadio}-${inforBlock.id}`"
                                                :value="VALUE_ETC"
                                                :label="inforBlock.setting_others.label_other"
                                                :disabled="disabled"
                                                :config.sync="configBlock.validateRadio[inforBlock.id].configField"
                                                @change="handleChangeRadio"
                                            />
                                            <template>
                                                <div :class="`d-flex flex-wrap`" :style="`gap: 10px; justify-content:${choicePlacement('answer')}`">
                                                    <InputText
                                                        :id="`RadioForm-Others-${index}-${indexRadio}-${inforBlock.id}`"
                                                        :model.sync="configBlock.modelRadio[inforBlock.id].text"
                                                        :config.sync="configBlock.validateRadio[inforBlock.id].configFieldText"
                                                        :disabled="configBlock.modelRadio[inforBlock.id].radio !== VALUE_ETC || disabled"
                                                        @blur="
                                                            handleValidateField(inforBlock, configBlock.validateRadio[inforBlock.id].configFieldText)
                                                        "
                                                    />
                                                </div>
                                                <div
                                                    v-if="configBlock.validateRadio[inforBlock.id].configFieldText.error"
                                                    :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                                >
                                                    {{ configBlock.validateRadio[inforBlock.id].configFieldText.errorField }}
                                                </div>
                                            </template>
                                        </div>
                                        <div v-if="inforBlock?.setting_others?.uncheck_use" :class="`mt-2 text-${choicePlacement('answer')}`">
                                            <button
                                                class="btn btn-light"
                                                :disabled="!configBlock.modelRadio[inforBlock.id].radio"
                                                @click="onHandleRemoveRadio"
                                            >
                                                {{
                                                    inforBlock.setting_others?.label_uncheck
                                                        ? inforBlock.setting_others.label_uncheck
                                                        : $t('managerForm.settingPage.uncheck')
                                                }}
                                            </button>
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validateRadio[inforBlock.id].configField.error &&
                                                !configBlock.validateRadio[inforBlock.id].configField.valueSync
                                            "
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateRadio[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{
                                configBlock.modelRadio[inforBlock.id].radio == VALUE_ETC
                                    ? `${inforBlock.setting_others.label_other}(${configBlock.modelRadio[inforBlock.id].text})`
                                    : renderValueOption(configBlock.modelRadio[inforBlock.id].radio)
                            }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SELECT && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />

                                    <div class="select_out">
                                        <Multiselect
                                            :id="`SelectForm-${inforBlock.id}-${index}-${indexMultiselect}`"
                                            :value.sync="configBlock.modelSelect[inforBlock.id]"
                                            :options="onHandleMergeOptionValues(inforBlock.option_value, inforBlock)"
                                            :config.sync="configBlock.validateSelect[inforBlock.id].configField"
                                            @remove="handleRemoveMultiselect(inforBlock, configBlock.validateSelect[inforBlock.id].configField)"
                                            @select="handleChangeMultiselect"
                                            style="width: 200px"
                                            :disabled="disabled"
                                        />
                                        <div
                                            v-if="configBlock.validateSelect[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateSelect[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ renderValueSelect(configBlock.modelSelect[inforBlock.id]) }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_CHECKBOX && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td
                        colspan="2"
                        :class="`fm-answer text-${inforBlock?.choice_placement_specification_answer}`"
                        :style="onHandleSetStyleAnswer(inforBlock)"
                    >
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            :style="`display: grid; grid-template-columns: repeat(${inforBlock.number_of_items_displayed_per_line}, auto)`"
                                        >
                                            <div v-for="item in inforBlock.option_value" :key="`CheckBoxForm-${item.unique_key}-${inforBlock.id}`">
                                                <InputCheckBox
                                                    class="mr-3 mb-2"
                                                    :id="`CheckBoxForm-${indexCheckbox}-${item.unique_key}-${inforBlock.id}`"
                                                    :model.sync="configBlock.modelCheckbox[inforBlock.id].checked"
                                                    :config.sync="configBlock.validateCheckbox[inforBlock.id].configField"
                                                    :value="item.unique_key"
                                                    :label="item.value"
                                                    :disabled="disabledLimit[item.unique_key] || disabled"
                                                    @change="
                                                        onChangeCheckbox(
                                                            configBlock.modelCheckbox[inforBlock.id],
                                                            configBlock.validateCheckbox[inforBlock.id]
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <div
                                            v-if="inforBlock?.setting_others?.other_use"
                                            :class="`text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            <InputCheckBox
                                                :id="`OtherCheckBoxForm-${indexCheckbox}-${inforBlock.id}`"
                                                class="mr-3 mb-2"
                                                :model.sync="configBlock.modelCheckbox[inforBlock.id].checked"
                                                :value="VALUE_ETC"
                                                :label="inforBlock.setting_others.label_other"
                                                :disabled="disabledLimit[VALUE_ETC] || disabled"
                                                :config.sync="configBlock.validateCheckbox[inforBlock.id].configField"
                                                @change="
                                                    onChangeCheckbox(
                                                        configBlock.modelCheckbox[inforBlock.id],
                                                        configBlock.validateCheckbox[inforBlock.id]
                                                    )
                                                "
                                            />
                                            <template>
                                                <div :class="`d-flex flex-wrap`" :style="`gap: 10px; justify-content:${choicePlacement('answer')}`">
                                                    <InputText
                                                        :id="`OtherCheckBoxForm-${index}-${indexTextCheckbox}-${inforBlock.id}`"
                                                        :model.sync="configBlock.modelCheckbox[inforBlock.id].text"
                                                        :config.sync="configBlock.validateCheckbox[inforBlock.id].configFieldText"
                                                        :disabled="!configBlock.modelCheckbox[inforBlock.id].checked.includes(VALUE_ETC) || disabled"
                                                        @blur="
                                                            handleValidateField(
                                                                inforBlock,
                                                                configBlock.validateCheckbox[inforBlock.id].configFieldText
                                                            )
                                                        "
                                                    />
                                                </div>
                                                <div
                                                    v-if="configBlock.validateCheckbox[inforBlock.id].configFieldText.error"
                                                    :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                                >
                                                    {{ configBlock.validateCheckbox[inforBlock.id].configFieldText.errorField }}
                                                </div>
                                            </template>
                                        </div>
                                        <div
                                            v-if="inforBlock?.setting_others?.uncheck_use"
                                            :class="`text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            <InputCheckBox
                                                :id="`NotApplicableCheckBoxForm-${indexCheckbox}-${inforBlock.id}`"
                                                :model.sync="configBlock.modelCheckbox[inforBlock.id].checked"
                                                :value="VALUE_NAC"
                                                :label="inforBlock.setting_others.label_uncheck"
                                                :disabled="disabledLimit[VALUE_NAC] || disabled"
                                                :config.sync="configBlock.validateCheckbox[inforBlock.id].configField"
                                                @change="
                                                    onChangeCheckbox(
                                                        configBlock.modelCheckbox[inforBlock.id],
                                                        configBlock.validateCheckbox[inforBlock.id],
                                                        'labelUncheck'
                                                    )
                                                "
                                            />
                                        </div>
                                        <div
                                            v-if="configBlock.validateCheckbox[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateCheckbox[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ onHandleJoinNameCheckbox(inforBlock.option_value, configBlock.modelCheckbox[inforBlock.id]) }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <UploadFileCommon
                                            :class="`text-${inforBlock?.choice_placement_specification_answer}`"
                                            @dataFile="handleFileForm"
                                            :id="`UploadFileForm-${inforBlock.id}-${indexUploadFile}`"
                                            :typeUpload="`file`"
                                            :config="{
                                                isUpDemo: true,
                                                isPreview: false,
                                                maxSize: convertMbToKb(inforBlock.block_upload_file.maximum_file_size),
                                                allowedExtension: onHandleJoinExtension(inforBlock.block_upload_file.allowed_extensions)
                                            }"
                                            :disabled="disabled"
                                        />
                                        <p :class="`mb-0 text-${inforBlock?.choice_placement_specification_answer}`">
                                            {{
                                                !inforBlock?.block_upload_file?.allowed_extensions
                                                    ? $t('managerForm.settingPage.noteAllowedUpload')
                                                    : `※アップロード可能なファイル形式：${inforBlock.block_upload_file.allowed_extensions}`
                                            }}
                                        </p>
                                        <div
                                            v-if="configBlock.validateUploadFile[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateUploadFile[inforBlock.id].configField.errorField }}
                                        </div>
                                        <div
                                            v-if="configBlock.modelUploadFile[inforBlock.id]?.origin_name"
                                            class="d-flex align-items-center my-2"
                                            :style="`justify-content:${choicePlacement('answer')}`"
                                        >
                                            <i
                                                v-if="arrImageExtension.includes(configBlock.modelUploadFile[inforBlock.id]?.extension.toLowerCase())"
                                                class="ri-file-image-line"
                                            ></i>
                                            <i v-else class="ri-file-line"></i>
                                            <p class="mb-0">{{ configBlock.modelUploadFile[inforBlock.id]?.origin_name }}</p>
                                            <span
                                                class="ml-2"
                                                style="cursor: pointer; font-size: 20px"
                                                @click="onHandleRemoveFile(inforBlock, configBlock.validateUploadFile[inforBlock.id].configField)"
                                                ><i class="ri-close-line" style="vertical-align: bottom"></i
                                            ></span>
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            <p class="mb-0">{{ configBlock.modelUploadFile[inforBlock.id]?.origin_name }}</p>
                        </div>
                    </td>
                </tr>
            </template>
            <template
                v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE && onHandleShowBlockOfPageConfirm(inforBlock.block_type)"
            >
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div class="select_out">
                                        <Multiselect
                                            :id="`SelectProvince-${inforBlock.id}-${index}-${indexProvince}`"
                                            :value.sync="configBlock.modelProvince[inforBlock.id]"
                                            :options="onHandleMergeOptionValues(inforBlock.option_value, inforBlock)"
                                            :config.sync="configBlock.validateProvince[inforBlock.id].configField"
                                            @select="handleChangeBlockProvince"
                                            @remove="handleValidateField(inforBlock, configBlock.validateProvince[inforBlock.id].configField)"
                                            :disabled="disabled"
                                            style="width: 200px"
                                        />
                                        <div
                                            v-if="configBlock.validateProvince[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateProvince[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ renderValueSelect(configBlock.modelProvince[inforBlock.id]) }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            class=""
                                            :style="`display: grid; grid-template-columns: repeat(${inforBlock.number_of_items_displayed_per_line}, auto)`"
                                        >
                                            <div v-for="item in inforBlock.option_value" :key="`RemainingSeats-${item.unique_key}-${inforBlock.id}`">
                                                <div
                                                    :class="`d-flex flex-wrap`"
                                                    :style="`gap: 10px; justify-content:${choicePlacement('answer')}`"
                                                    style="gap: 5px"
                                                >
                                                    <InputRadio
                                                        class="mb-2"
                                                        :model.sync="configBlock.modelRemainingBox[inforBlock.id]"
                                                        :name="`RemainingSeats-${inforBlock.id}`"
                                                        :id="`RemainingSeats-${item.unique_key}-${inforBlock.id}-${indexRemainingBox}`"
                                                        :value="item.unique_key"
                                                        :label="item.value"
                                                        :config.sync="configBlock.validateRemainingBox[inforBlock.id].configField"
                                                        @change="handleChangeRemainingBox"
                                                        :disabled="disabled"
                                                    />
                                                    <div v-if="inforBlock.block_remaining_number.remaining_number === 1">
                                                        <span
                                                            :style="`color: ${inforBlock.block_remaining_number.color_text ?? ''}; font-size: 12px`"
                                                            class="fm_limit_radio_remainder pt-1"
                                                        >
                                                            {{
                                                                `${inforBlock.block_remaining_number.display_content === 1 ? `(${inforBlock.block_remaining_number.remaining_text}${item.number_of_receptions}${inforBlock.block_remaining_number.text_after_remaining_number})` : inforBlock.block_remaining_number.label_other}`
                                                            }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-if="!inforBlock.order_required && inforBlock?.setting_others?.uncheck_use"
                                            :class="`mt-2 text-${choicePlacement('answer')}`"
                                        >
                                            <button
                                                class="btn btn-light"
                                                :disabled="!configBlock.modelRemainingBox[inforBlock.id]"
                                                @click="onHandleRemoveRemainingBox"
                                            >
                                                {{
                                                    inforBlock.setting_others?.label_uncheck
                                                        ? inforBlock.setting_others.label_uncheck
                                                        : $t('managerForm.settingPage.uncheck')
                                                }}
                                            </button>
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validateRemainingBox[inforBlock.id].configField.error &&
                                                !configBlock.validateRemainingBox[inforBlock.id].configField.valueSync
                                            "
                                            :class="`form__alert--error text-${inforBlock?.choice_placement_specification_answer}`"
                                        >
                                            {{ configBlock.validateRemainingBox[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ renderValueOption(configBlock.modelRemainingBox[inforBlock.id]) }}
                        </div>
                    </td>
                </tr>
            </template>
        </template>
    </tbody>
</template>

<script>
import { InputRadio, InputCheckBox, InputText } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { renderLineBreaks } from '@/utils/format';
import { onHandleCheckboxLimited, onHandleMergeOptionValues } from '../../handlers';
import { PAGE_TYPES } from '../../constants';
import {
    matchingMessageBlocks,
    incrementIndex,
    VALUE_ETC,
    VALUE_NAC,
    VALUE_NS,
    onHandleMapCssForm,
    onHandleGetValueTextAlign,
    onHandleSetStyleLabel
} from '../handlers';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { CONFIRMATION_PAGE_DISPLAY } from '../../components/setting-block-form/constants';

import Multiselect from '@/components/Multiselect/main.vue';
import UploadFileCommon from '@/components/Uploads/Files/main.vue';
import { IMAGE_EXTENSIONS, convertMbToKb } from '@/utils/format';

export default {
    name: 'CommonOption',
    components: {
        InputRadio,
        InputCheckBox,
        InputText,
        Multiselect,
        UploadFileCommon
    },
    props: {
        index: {
            type: Number,
            default: () => 0
        },
        conditionPageShow: {
            type: String,
            default: () => 'input'
        },
        inforBlock: {
            type: Object,
            default: () => null
        },
        addressInfor: {
            type: Object,
            default: () => null
        },
        settingDesign: {
            type: Object,
            default: () => null
        },
        configBlock: {
            type: Object,
            default: () => null
        },
        pagePreview: {
            type: Boolean,
            default: () => false
        },
        disabled: {
            type: Boolean,
            default: () => false
        },
        settingRequireLabel: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            VALUE_ETC: VALUE_ETC,
            VALUE_NAC: VALUE_NAC,
            VALUE_NS: VALUE_NS,
            indexMultiselect: 0,
            indexCheckbox: 0,
            indexTextCheckbox: 0,
            indexRadio: 0,
            indexProvince: 0,
            indexUploadFile: 0,
            indexRemainingBox: 0,
            disabledLimit: {},
            previousCheckedState: [],
            tempDisabledValues: null, // nơi lưu giá trị tạm
            arrImageExtension: IMAGE_EXTENSIONS
        };
    },
    computed: {
        formGroupLayout() {
            return this.inforBlock.layout == 'default'
                ? this.settingDesign.table_settings.question_layout === 'horizontal'
                    ? 'row'
                    : 'cols'
                : this.inforBlock.layout;
        },
        labelLayout() {
            return (
                ['row'].includes(this.inforBlock.layout) ||
                (this.inforBlock.layout === 'default' && this.settingDesign.table_settings.question_layout == 'horizontal')
            );
        },
        defineShowTypeBlock() {
            return [PAGE_TYPES._A[0], PAGE_TYPES._B[0], 'prize_serial'].includes(this.conditionPageShow);
        },

        isShowBlockOfPageConfirm() {
            if (this.defineShowTypeBlock) return true;
            return this.inforBlock.confirmation_page_display == CONFIRMATION_PAGE_DISPLAY[0].id;
        }
    },
    methods: {
        onHandleMergeOptionValues,
        onHandleMapCssForm,
        onHandleSetStyleLabel,
        convertMbToKb,

        choicePlacement(type) {
            switch (type) {
                case 'question':
                    return this.inforBlock.choice_placement_specification_question === 'default'
                        ? onHandleGetValueTextAlign(this.settingDesign.table_settings.question_text_alignment.horizontal)
                        : this.inforBlock.choice_placement_specification_question;
                case 'answer':
                    return this.inforBlock.choice_placement_specification_answer === 'default'
                        ? onHandleGetValueTextAlign(this.settingDesign.table_settings.answer_text_alignment.horizontal)
                        : this.inforBlock.choice_placement_specification_answer;
            }
        },

        onHandleShowBlockOfPageConfirm(blockType) {
            const blockConfig = this.configBlock;
            const forIn = this.inforBlock;
            if (this.defineShowTypeBlock) return true;
            if (this.inforBlock.confirmation_page_display == CONFIRMATION_PAGE_DISPLAY[1].id) {
                switch (blockType) {
                    case ALL_BLOCK_TYPE.BLOCK_RADIO:
                        return blockConfig.modelRadio[forIn.id].radio !== '';
                    case ALL_BLOCK_TYPE.BLOCK_SELECT:
                        return blockConfig.modelSelect[forIn.id]?.unique_key !== null;
                    case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                        return blockConfig.modelCheckbox[forIn.id].checked?.length > 0;
                    case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                        return blockConfig.modelUploadFile[forIn.id] !== null;
                    case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                        return blockConfig.modelProvince[forIn.id]?.unique_key !== null;
                    case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
                        return !!blockConfig.modelRemainingBox[forIn.id];
                }
            }
            return true;
        },

        handleFileForm(file) {
            this.configBlock.modelUploadFile[this.inforBlock.id] = file;
            this.configBlock.validateUploadFile[this.inforBlock.id].configField.valueSync = file;
            this.configBlock.validateUploadFile[this.inforBlock.id].configField.error = false;
            this.indexUploadFile = incrementIndex(this.indexUploadFile);
            this.$emit('emitChange');
        },

        onHandleRemoveFile(blockInfor, configField) {
            this.configBlock.modelUploadFile[this.inforBlock.id] = null;
            this.configBlock.validateUploadFile[this.inforBlock.id].configField.valueSync = null;
            this.indexUploadFile--;
            matchingMessageBlocks(this.configBlock, [], blockInfor);
            validateField(configField);
            this.$emit('emitChange');
        },

        handleChangeMultiselect() {
            this.indexMultiselect = incrementIndex(this.indexMultiselect);
            this.$emit('emitChange');
        },
        handleChangeBlockProvince(valueProvince) {
            this.indexProvince = incrementIndex(this.indexProvince);
            this.$emit('selectProvince', { ...valueProvince, block_select_province: this.inforBlock.block_select_province });
            this.$emit('emitChange');
        },

        handleRemoveMultiselect(blockInfor, configField) {
            this.indexMultiselect--;
            this.indexProvince--;
            matchingMessageBlocks(this.configBlock, [], blockInfor);
            validateField(configField);
        },

        handleValidateField(blockInfor, configField) {
            const blockType = blockInfor.block_type;
            validateField(configField);
            if (
                [
                    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                    ALL_BLOCK_TYPE.BLOCK_SELECT,
                    ALL_BLOCK_TYPE.BLOCK_RADIO,
                    ALL_BLOCK_TYPE.BLOCK_CHECKBOX
                ].includes(blockType)
            ) {
                matchingMessageBlocks(this.configBlock, [], blockInfor);
            }

            switch (blockType) {
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                    this.indexTextCheckbox = incrementIndex(this.indexTextCheckbox);
                    break;
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                    this.indexRadio = incrementIndex(this.indexRadio);
                    break;
                case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                    this.indexProvince = incrementIndex(this.indexProvince);
                    break;
            }
            this.$emit('emitChange');
        },

        textLineBreaks(text) {
            return renderLineBreaks(text);
        },

        handleChangeRadio(modelRadio) {
            let { configField, configFieldText } = this.configBlock.validateRadio[this.inforBlock.id];
            configField.valueSync = modelRadio;
            if (modelRadio !== VALUE_ETC) {
                configFieldText.error = false;
                configField.typesValidate = configField.typesValidate.filter((type) => type !== 'required_other');
            } else {
                if (this.inforBlock.setting_others.value_other_required) {
                    configField.typesValidate.push('required_other');
                }
            }
            this.indexRadio = incrementIndex(this.indexRadio);
            this.$emit('emitChange');
        },

        handleChangeRemainingBox(modelRemainingBox) {
            const foundChoiceRemainingBox = this.inforBlock.option_value.find((choice) => choice.unique_key == modelRemainingBox);
            this.indexRemainingBox = incrementIndex(this.indexRemainingBox);
            this.configBlock.validateRemainingBox[this.inforBlock.id].configField.valueSync = modelRemainingBox;
            this.configBlock.validateRemainingBox[this.inforBlock.id].configField.numberRemainingBox = foundChoiceRemainingBox?.number_of_receptions
                ? Number(foundChoiceRemainingBox?.number_of_receptions)
                : null;
            this.$emit('emitChange');
        },

        onHandleRemoveRadio() {
            this.indexRadio = incrementIndex(this.indexRadio);

            this.configBlock.modelRadio[this.inforBlock.id].radio = '';
            this.configBlock.modelRadio[this.inforBlock.id].text = '';
            this.configBlock.validateRadio[this.inforBlock.id].configField.valueSync = '';
            this.configBlock.validateRadio[this.inforBlock.id].configFieldText.valueSync = '';
            this.configBlock.validateRadio[this.inforBlock.id].configFieldText.error = false;
            if (this.configBlock.modelRadio[this.inforBlock.id].radio !== VALUE_ETC) {
                this.configBlock.validateRadio[this.inforBlock.id].configFieldText.error = false;
                this.configBlock.validateRadio[this.inforBlock.id].configField.typesValidate = this.configBlock.validateRadio[
                    this.inforBlock.id
                ].configField.typesValidate.filter((type) => type !== 'required_other');
            }
            this.$emit('emitChange');
        },

        onChangeCheckbox(modelInforBlock, configInforBlock, typeAction = null) {
            this.indexCheckbox++;
            this.indexCheckbox = this.indexCheckbox >= 100 ? 0 : this.indexCheckbox;
            if (typeAction === 'labelUncheck') {
                if (modelInforBlock.checked.includes(VALUE_NAC)) {
                    this.previousCheckedState = [...this.configBlock.modelCheckbox[this.inforBlock.id].checked];
                    this.configBlock.modelCheckbox[this.inforBlock.id].checked = [VALUE_NAC];
                    this.inforBlock.option_value.forEach((optionItem) => {
                        this.disabledLimit[Number(optionItem.unique_key)] = true;
                    });
                    this.disabledLimit[VALUE_ETC] = true;
                } else {
                    this.previousCheckedState = this.previousCheckedState.filter((prItem) => prItem !== VALUE_NAC);
                    this.configBlock.modelCheckbox[this.inforBlock.id].checked = [...this.previousCheckedState];
                    this.inforBlock.option_value.forEach((optionItem) => {
                        this.disabledLimit[Number(optionItem.unique_key)] = false;
                    });
                    this.disabledLimit[VALUE_ETC] = false;
                }

                if (!modelInforBlock.checked.includes(VALUE_ETC)) {
                    configInforBlock.configField.typesValidate = configInforBlock.configField.typesValidate.filter(
                        (type) => type !== 'required_other'
                    );
                } else {
                    if (this.inforBlock.setting_others?.value_other_required) configInforBlock.configField.typesValidate.push('required_other');
                }
                modelInforBlock.text = '';
                configInforBlock.configFieldText.error = false;
                this.$emit('emitChange');
                return;
            }

            if (!modelInforBlock.checked.includes(VALUE_ETC)) {
                modelInforBlock.text = '';
                configInforBlock.configFieldText.error = false;
                configInforBlock.configField.typesValidate = configInforBlock.configField.typesValidate.filter((type) => type !== 'required_other');
            } else {
                if (this.inforBlock.setting_others?.value_other_required) configInforBlock.configField.typesValidate.push('required_other');
            }
            this.disabledLimit = onHandleCheckboxLimited(this.inforBlock, modelInforBlock, this.disabledLimit, 'action');
            this.indexTextCheckbox = incrementIndex(this.indexTextCheckbox);
            this.$emit('emitChange');
        },

        renderValueOption(idOption) {
            return this.inforBlock.option_value.find((optionValueItem) => optionValueItem.unique_key === idOption)?.value ?? '';
        },

        renderValueSelect(valueOption) {
            return valueOption?.unique_key ? valueOption?.value : '';
        },

        onHandleJoinNameCheckbox(options, configChecked) {
            const { checked, text } = configChecked;
            const { setting_others } = this.inforBlock;
            const listName = options.filter((opItem) => checked.includes(opItem.unique_key)).map((opItem) => opItem.value);
            if (checked.includes(VALUE_ETC)) {
                listName.push(`${setting_others.label_other}(${text})`);
            }
            if (checked.includes(VALUE_NAC)) {
                listName.push(setting_others.label_uncheck);
            }
            return listName.join(',');
        },

        onHandleJoinExtension(extensions) {
            return extensions?.length > 0 && extensions
                ? extensions.split(',')
                : ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx', 'doc', 'docx', 'heic', 'mp4', 'mov', 'wmv'];
        },

        onHandleRemoveRemainingBox() {
            this.configBlock.modelRemainingBox[this.inforBlock.id] = '';
            this.configBlock.validateRemainingBox[this.inforBlock.id].configField.valueSync = '';
            this.indexRemainingBox = incrementIndex(this.indexRemainingBox);
            this.$emit('emitChange');
        },

        onHandleSetStyleQuestion(blockInfor) {
            return `${blockInfor.cell_background_color.is_bg_question_default ? '' : `background-color:${blockInfor?.cell_background_color?.bg_question}`} `;
        },

        onHandleSetStyleAnswer(blockInfor) {
            return `${blockInfor.cell_background_color.is_bg_answer_default ? '' : `background-color:${blockInfor?.cell_background_color?.bg_answer}`} `;
        }
    },
    watch: {
        inforBlock: {
            handler(newInforBlock) {
                this.disabledLimit = onHandleCheckboxLimited(newInforBlock, null, this.disabledLimit, 'created') ?? {};
            },
            immediate: true
        },
        disabled: {
            handler(newDisabled) {
                // đảm bảo object tempDisabledValues[modelKey] tồn tại
                if (!this.tempDisabledValues) {
                    this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                }
                switch (this.inforBlock.block_type) {
                    case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelCheckbox[this.inforBlock.id].checked = [];
                            this.configBlock.modelCheckbox[this.inforBlock.id].text = '';
                            this.configBlock.validateCheckbox[this.inforBlock.id].configField.error = false;
                            this.configBlock.validateCheckbox[this.inforBlock.id].configFieldText.error = false;
                        } else {
                            this.configBlock.modelCheckbox[this.inforBlock.id] = this.tempDisabledValues.modelCheckbox[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_RADIO:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelRadio[this.inforBlock.id].radio = '';
                            this.configBlock.modelRadio[this.inforBlock.id].text = '';
                            this.configBlock.validateRadio[this.inforBlock.id].configField.error = false;
                            this.configBlock.validateRadio[this.inforBlock.id].configFieldText.error = false;
                        } else {
                            this.configBlock.modelRadio[this.inforBlock.id] = this.tempDisabledValues.modelRadio[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_SELECT:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelSelect[this.inforBlock.id] = { unique_key: null, value: '' };
                            this.configBlock.validateSelect[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelSelect[this.inforBlock.id] = this.tempDisabledValues.modelSelect[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelProvince[this.inforBlock.id] = { unique_key: null, value: '' };
                            this.configBlock.validateProvince[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelProvince[this.inforBlock.id] = this.tempDisabledValues.modelProvince[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelUploadFile[this.inforBlock.id] = null;
                            this.configBlock.validateUploadFile[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelUploadFile[this.inforBlock.id] = this.tempDisabledValues.modelUploadFile[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelRemainingBox[this.inforBlock.id] = '';
                            this.configBlock.validateRemainingBox[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelRemainingBox[this.inforBlock.id] = this.tempDisabledValues.modelRemainingBox[this.inforBlock.id];
                        }
                        break;
                    default:
                        break;
                }
            }
        },

        addressInfor: {
            handler(newInforBlock) {
                if (
                    newInforBlock &&
                    this.configBlock.modelProvince[newInforBlock?.id_select_province] &&
                    this.inforBlock.block_type === ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE
                ) {
                    const foundIndexProvince = this.inforBlock.option_value.findIndex((item) => item.value == newInforBlock?.prefecture);
                    if (foundIndexProvince === -1) return;
                    this.configBlock.modelProvince[newInforBlock.id_select_province] = this.inforBlock.option_value[foundIndexProvince] ?? null;
                    this.configBlock.validateProvince[newInforBlock.id_select_province].configField.error = false;
                    this.indexProvince = incrementIndex(this.indexProvince);
                }
            },
            immediate: true
        },

        settingDesign: {
            handler() {
                if (!this.settingDesign) return;
                onHandleMapCssForm(this.settingDesign);
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
